import React from 'react';

const QualifiedEvaluationSection = ({ qualifiedEvaluation }) => {
    if (!qualifiedEvaluation) {
        return null;
    }

    const { 
        passed, 
        checks, 
        details 
    } = qualifiedEvaluation;

    // Get status visuals
    const getStatusVisuals = () => {
        if (passed) {
            return {
                accent: '#34d399',
                border: 'rgba(52, 211, 153, 0.65)',
                gradient: 'linear-gradient(135deg, rgba(52, 211, 153, 0.24), rgba(52, 211, 153, 0.08))',
                shadow: 'rgba(52, 211, 153, 0.22)',
                label: 'Passed',
                backgroundColor: 'rgba(52, 211, 153, 0.2)',
                color: '#34d399'
            };
        }
        return {
            accent: '#f87171',
            border: 'rgba(248, 113, 113, 0.65)',
            gradient: 'linear-gradient(135deg, rgba(248, 113, 113, 0.22), rgba(248, 113, 113, 0.08))',
            shadow: 'rgba(248, 113, 113, 0.2)',
            label: 'Failed',
            backgroundColor: 'rgba(248, 113, 113, 0.2)',
            color: '#f87171'
        };
    };

    const statusVisuals = getStatusVisuals();

    return (
        <div style={{ marginBottom: '30px' }}>
            <h4 style={{ marginBottom: '15px', color: '#e0e0e0', fontWeight: '600' }}>Qualified Evaluation</h4>
            <div style={{
                background: '#2d2d2d',
                border: '1px solid #404040',
                borderRadius: '16px',
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '20px'
            }}>
                {/* Overall Status */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <span style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        padding: '6px 16px',
                        borderRadius: '999px',
                        fontSize: '14px',
                        fontWeight: 600,
                        letterSpacing: '0.4px',
                        backgroundColor: statusVisuals.backgroundColor,
                        color: statusVisuals.color,
                        border: `1px solid ${statusVisuals.border}`
                    }}>
                        {statusVisuals.label}
                    </span>
                </div>

                {/* Checks */}
                {checks && typeof checks === 'object' && Object.keys(checks).length > 0 && (
                    <div>
                        <h5 style={{
                            color: '#e0e0e0',
                            fontSize: '14px',
                            fontWeight: '600',
                            marginBottom: '12px',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                        }}>
                            Checks
                        </h5>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '8px'
                        }}>
                            {Object.entries(checks).map(([key, check]) => (
                                <div key={key} style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '10px 12px',
                                    background: 'rgba(255, 255, 255, 0.03)',
                                    borderRadius: '8px',
                                    border: `1px solid ${check.passed ? 'rgba(52, 211, 153, 0.3)' : 'rgba(248, 113, 113, 0.3)'}`
                                }}>
                                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                        <span style={{
                                            color: '#d0d0d0',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            textTransform: 'capitalize'
                                        }}>
                                            {key.replace(/_/g, ' ')}
                                        </span>
                                        {check.reason && (
                                            <span style={{
                                                color: '#9ca3af',
                                                fontSize: '12px'
                                            }}>
                                                {check.reason}
                                            </span>
                                        )}
                                    </div>
                                    <span style={{
                                        color: check.passed ? '#34d399' : '#f87171',
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        marginLeft: '12px',
                                        padding: '4px 8px',
                                        borderRadius: '4px',
                                        backgroundColor: check.passed ? 'rgba(52, 211, 153, 0.1)' : 'rgba(248, 113, 113, 0.1)'
                                    }}>
                                        {check.passed ? '✓' : '✗'}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Details */}
                {details && typeof details === 'object' && Object.keys(details).length > 0 && (
                    <div>
                        <h5 style={{
                            color: '#e0e0e0',
                            fontSize: '14px',
                            fontWeight: '600',
                            marginBottom: '12px',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                        }}>
                            Details
                        </h5>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                            gap: '12px'
                        }}>
                            {details.total_contacts !== undefined && (
                                <div style={{
                                    padding: '12px',
                                    background: 'rgba(255, 255, 255, 0.03)',
                                    borderRadius: '8px',
                                    border: '1px solid rgba(255, 255, 255, 0.05)'
                                }}>
                                    <span style={{
                                        color: '#9ca3af',
                                        fontSize: '12px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}>
                                        Total Contacts
                                    </span>
                                    <div style={{
                                        fontSize: '20px',
                                        fontWeight: '700',
                                        color: '#f9fafb',
                                        marginTop: '4px'
                                    }}>
                                        {details.total_contacts}
                                    </div>
                                </div>
                            )}
                            {details.good_contacts_count !== undefined && (
                                <div style={{
                                    padding: '12px',
                                    background: 'rgba(255, 255, 255, 0.03)',
                                    borderRadius: '8px',
                                    border: '1px solid rgba(255, 255, 255, 0.05)'
                                }}>
                                    <span style={{
                                        color: '#9ca3af',
                                        fontSize: '12px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}>
                                        Good Contacts
                                    </span>
                                    <div style={{
                                        fontSize: '20px',
                                        fontWeight: '700',
                                        color: '#34d399',
                                        marginTop: '4px'
                                    }}>
                                        {details.good_contacts_count}
                                    </div>
                                </div>
                            )}
                            {details.total_pages_crawled !== undefined && (
                                <div style={{
                                    padding: '12px',
                                    background: 'rgba(255, 255, 255, 0.03)',
                                    borderRadius: '8px',
                                    border: '1px solid rgba(255, 255, 255, 0.05)'
                                }}>
                                    <span style={{
                                        color: '#9ca3af',
                                        fontSize: '12px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}>
                                        Pages Crawled
                                    </span>
                                    <div style={{
                                        fontSize: '20px',
                                        fontWeight: '700',
                                        color: '#f9fafb',
                                        marginTop: '4px'
                                    }}>
                                        {details.total_pages_crawled}
                                    </div>
                                </div>
                            )}
                            {details.max_pages_reached !== undefined && details.max_pages_reached && (
                                <div style={{
                                    padding: '12px',
                                    background: 'rgba(239, 68, 68, 0.1)',
                                    borderRadius: '8px',
                                    border: '1px solid rgba(239, 68, 68, 0.3)'
                                }}>
                                    <span style={{
                                        color: '#ef4444',
                                        fontSize: '12px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}>
                                        Max Pages Reached
                                    </span>
                                    <div style={{
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: '#ef4444',
                                        marginTop: '4px'
                                    }}>
                                        Yes
                                    </div>
                                </div>
                            )}
                        </div>
                        {details.contact_scores && Array.isArray(details.contact_scores) && details.contact_scores.length > 0 && (
                            <div style={{ marginTop: '16px' }}>
                                <span style={{
                                    color: '#9ca3af',
                                    fontSize: '12px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Contact Scores
                                </span>
                                <div style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '8px'
                                }}>
                                    {details.contact_scores.map((score, index) => (
                                        <span key={index} style={{
                                            padding: '6px 12px',
                                            borderRadius: '6px',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            backgroundColor: score >= 5 ? 'rgba(52, 211, 153, 0.15)' : 'rgba(156, 163, 175, 0.15)',
                                            color: score >= 5 ? '#34d399' : '#9ca3af',
                                            border: `1px solid ${score >= 5 ? 'rgba(52, 211, 153, 0.3)' : 'rgba(156, 163, 175, 0.3)'}`
                                        }}>
                                            {score}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}
                        {details.crawl_error && details.crawl_error.trim() !== '' && (
                            <div style={{
                                marginTop: '16px',
                                padding: '12px',
                                background: 'rgba(239, 68, 68, 0.1)',
                                borderRadius: '8px',
                                border: '1px solid rgba(239, 68, 68, 0.3)'
                            }}>
                                <span style={{
                                    color: '#ef4444',
                                    fontSize: '12px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    Crawl Error
                                </span>
                                <span style={{
                                    color: '#f0f0f0',
                                    fontSize: '13px'
                                }}>
                                    {details.crawl_error}
                                </span>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default QualifiedEvaluationSection;

